import { createUseStyles } from 'react-jss'

import { mediumGrey, backgroundGrey } from '../../../../../styles/const/colors'
import { zIndex10 } from '../../../../../styles/const/common'

export default createUseStyles(theme => ({
  adImage: {
    height: ({ mediaPreviewHeight }) => mediaPreviewHeight,
    minHeight: ({ mediaPreviewHeight }) => (mediaPreviewHeight === 'auto' ? 'unset' : mediaPreviewHeight),
    maxHeight: ({ mediaPreviewHeight }) => (mediaPreviewHeight === 'auto' ? 'unset' : mediaPreviewHeight),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: '100%'
    },
    '& video': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },
  adImageBlue: {
    backgroundColor: theme.brandPrimary
  },
  adImageGrey: {
    backgroundColor: backgroundGrey
  },
  skeletonContainer: {
    position: 'relative',
    height: '100%'
  },
  processingMessage: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: 200,
    textAlign: 'center',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    margin: 0,
    fontSize: 14,
    lineHeight: '16px',
    color: mediumGrey,
    fontWeight: 'bold',
    zIndex: zIndex10
  }
}))
